<div class="header">
  <h4 class="header-text">{{ "ordersHistory.dialog.title" | translate }}</h4>
  @if (!isDesktop()) {
    <iw-button
      size="s"
      uiType="custom"
      [onlyIcon]="true"
      class="header-filter-btn"
      (click)="openFiltersDialog()"
    >
      <fu-icon [iconName]="!filtersDirty ? 'filter' : 'filter-set'" size="16" />
    </iw-button>
  }
</div>

@if (!initializing()) {
  @if (!ongoingOrders()?.items?.length) {
    @if (!isDesktop()) {
      <div class="section empty-ongoing">
        <div>
          <h4 class="empty-ongoing-title">
            {{ "ordersHistory.dialog.table.empty.ongoing.title" | translate }}
          </h4>
          <p class="empty-ongoing-text">
            {{ "ordersHistory.dialog.table.empty.ongoing.text" | translate }}
          </p>
        </div>
        <iw-button
          size="s"
          iconName="plus"
          uiType="primary"
          iconPosition="right"
          class="empty-ongoing-btn"
          (click)="openWithdrawal()"
        >
          {{ "ordersHistory.dialog.table.create" | translate }}
        </iw-button>
      </div>
    }
  } @else {
    <section class="ongoing section" [class.max-h-none]="!showOrders()">
      @if (isDesktop()) {
        <iw-title [title]="'ordersHistory.table.ongoing' | translate" />
      }
      <iw-table
        class="table"
        [divideRows]="false"
        [data]="ongoingOrders()"
        [filters]="ongoingFilters()"
        (loadMore)="loadMoreOngoing()"
        [columns]="ongoingOrdersColumns"
        [isLoading]="loadingOngoingOrders()"
        [gridTemplateColumns]="gridTemplateColumns"
      >
        <ng-template let-operation>
          @let currency = operation.currency;

          <section (click)="openDetails({ id: operation.id })">
            <div class="align-center">
              <span>{{ operation.createdAt | date: "dd.MM.yyyy" }}</span>
              &nbsp;
              <span class="date-time">{{
                operation.createdAt | date: "HH:mm:ss"
              }}</span>
            </div>

            <div class="align-center">
              <span>{{ operation.updatedAt | date: "dd.MM.yyyy" }}</span>
              &nbsp;
              <span class="date-time">{{
                operation.updatedAt | date: "HH:mm:ss"
              }}</span>
            </div>

            <div>
              {{ operation.details.method }}
            </div>

            <div>
              <iw-status-card [status]="operation.status" />
            </div>

            <div class="operation-currency">
              {{ currency.symbol }}
            </div>

            <div>
              <span [title]="operation.amount">
                {{ operation.amount | decimal: "1.2-8" }}
              </span>
            </div>

            <div>
              <div class="btn-group">
                <iw-button
                  size="s"
                  iconName="chats"
                  [onlyIcon]="true"
                  uiType="secondary"
                  [disabled]="cancelPending()"
                  (click)="
                    $event.stopPropagation();
                    openDetails({ id: operation.id, openMessages: true })
                  "
                />
                <iw-button
                  size="s"
                  alignX="end"
                  alignY="bottom"
                  [onlyIcon]="true"
                  uiType="secondary"
                  [inheritWidth]="false"
                  iconName="dots-vertical"
                  [disabled]="cancelPending()"
                  (click)="$event.stopPropagation()"
                  [fuDropdownTriggerFor]="ongoingMenu"
                />
              </div>
            </div>
          </section>
          <fu-dropdown #ongoingMenu [closeOnClick]="true">
            <div class="menu">
              <button
                fuButton
                class="menu-item"
                (click)="openCancelConfirm(operation)"
                [disabled]="operation.status !== OperationStatus.Created"
              >
                {{ "ordersHistory.menu.cancel" | translate }}
              </button>
            </div>
          </fu-dropdown>
        </ng-template>
        <ng-template let-operation #mobile>
          @let currency = operation.currency;
          @let targetCurrency = operation.targetCurrency;
          @let isExchange = !!(targetCurrency && targetCurrency !== currency);

          <section
            class="operation"
            (click)="openDetails({ id: operation.id })"
          >
            <div class="align-center operation-date">
              <span>{{ operation.createdAt | date: "dd.MM.yyyy" }}</span>
              <span class="date-time">{{
                operation.createdAt | date: "HH:mm:ss"
              }}</span>
            </div>

            <div class="operation-status">
              <iw-status-card [status]="operation.status" />
            </div>

            <div class="operation-method">
              <span class="operation-method-value">
                {{ operation.details.method }}
              </span>
              <span class="operation-id">ID: {{ operation.id }}</span>
            </div>

            <div class="operation-amount">
              @if (isExchange) {
                <div class="operation-amount-receive">
                  {{ targetCurrency.symbol }}
                  {{ operation.details.amountToReceive | decimal: "1.2-8" }}
                </div>
              }

              <div class="operation-amount-send" [class.exchange]="isExchange">
                {{ currency.symbol }}
                {{ operation.amount | decimal: "1.2-8" }}
              </div>
            </div>
          </section>
        </ng-template>
      </iw-table>
    </section>
  }
}
@if (!isDesktop() && !initializing() && showOrders()) {
  <hr class="separator" />
}
@if (initializing() || showOrders()) {
  <section class="orders section">
    @if (showFilters()) {
      <iw-orders-filters />
    }
    <iw-table
      class="table"
      [data]="orders()"
      [divideRows]="false"
      [filters]="filters()"
      (loadMore)="loadMore()"
      [isLoading]="loadingOrders()"
      [gridTemplateColumns]="gridTemplateColumns"
      [columns]="showFilters() || !isDesktop() ? columns : []"
    >
      <ng-template let-operation>
        @let currency = operation.currency;

        <section class="operation" (click)="openDetails({ id: operation.id })">
          <div class="align-center">
            <span>{{ operation.createdAt | date: "dd.MM.yyyy" }}</span>
            &nbsp;
            <span class="date-time">{{
              operation.createdAt | date: "HH:mm:ss"
            }}</span>
          </div>

          <div class="align-center">
            <span>{{ operation.updatedAt | date: "dd.MM.yyyy" }}</span>
            &nbsp;
            <span class="date-time">{{
              operation.updatedAt | date: "HH:mm:ss"
            }}</span>
          </div>

          <div>
            {{ operation.details.method }}
          </div>

          <div>
            <iw-status-card [status]="operation.status" />
          </div>

          <div>
            {{ currency.symbol }}
          </div>

          <div>
            <span [title]="operation.amount">
              {{ operation.amount | decimal: "1.2-8" }}
            </span>
          </div>

          <div>
            <div class="btn-group">
              <iw-button
                size="s"
                [onlyIcon]="true"
                uiType="secondary"
                [iconName]="'chats'"
                (click)="
                  $event.stopPropagation();
                  openDetails({ id: operation.id, openMessages: true })
                "
              />
            </div>
          </div>
        </section>
      </ng-template>

      <ng-template let-operation #mobile>
        @let currency = operation.currency;
        @let targetCurrency = operation.targetCurrency;
        @let withExchange = !!(targetCurrency && targetCurrency !== currency);

        <section class="operation" (click)="openDetails({ id: operation.id })">
          <div class="align-center operation-date">
            <span>{{ operation.createdAt | date: "dd.MM.yyyy" }}</span>
            <span class="date-time">{{
              operation.createdAt | date: "HH:mm:ss"
            }}</span>
          </div>

          <div class="operation-status">
            <iw-status-card [status]="operation.status" />
          </div>

          <div class="operation-method">
            <span>
              {{ operation.details.method }}
            </span>
            <span class="operation-id">ID: {{ operation.id }}</span>
          </div>

          <div class="operation-amount">
            @if (withExchange) {
              <div class="operation-amount-receive">
                {{ targetCurrency.symbol }}
                {{ operation.details.amountToReceive | decimal: "1.2-8" }}
              </div>
            }

            <div class="operation-amount-send" [class.exchange]="withExchange">
              {{ currency.symbol }}
              {{ operation.amount | decimal: "1.2-8" }}
            </div>
          </div>
        </section>
      </ng-template>

      <ng-template #empty>
        <div class="empty">
          <fu-icon iconName="not-found" size="32" />
          <h3 class="empty-title">
            {{
              (filtersDirty
                ? "ordersHistory.dialog.table.filtered.emptyTitle"
                : "ordersHistory.dialog.table.emptyTitle"
              ) | translate
            }}
          </h3>
          <p class="empty-description">
            {{
              (filtersDirty
                ? "ordersHistory.dialog.table.filtered.emptyMessage"
                : "ordersHistory.dialog.table.emptyMessage"
              ) | translate
            }}
          </p>
          @if (!filtersDirty) {
            <iw-button
              size="m"
              iconName="plus"
              uiType="primary"
              class="empty-btn"
              iconPosition="right"
              (click)="openWithdrawal()"
            >
              {{ "ordersHistory.dialog.table.createOrder" | translate }}
            </iw-button>
          }
        </div>
      </ng-template>
    </iw-table>
  </section>
}
